import { Controller } from 'stimulus';

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

export default class extends Controller {
  static targets = ['startDate', 'endDate'];
  static values = { maximumDays: Number, maximumRangeMessage: String };

  clearValidation() { this.endDateTarget.setCustomValidity(''); }

  validate(event) {
    this.endDateTarget.setCustomValidity('');
    if (!this.startDateTarget.value || !this.endDateTarget.value) return;

    const start = new Date(`${this.startDateTarget.value}T00:00:00Z`);
    const end = new Date(`${this.endDateTarget.value}T00:00:00Z`);
    const inclusiveDays = Math.floor((end - start) / MILLISECONDS_PER_DAY) + 1;
    if (inclusiveDays <= this.maximumDaysValue) return;

    event.preventDefault();
    event.stopPropagation();
    this.endDateTarget.setCustomValidity(this.maximumRangeMessageValue);
    this.endDateTarget.reportValidity();
  }
}
